import { useState } from "react";
import { useRouter, useSearch } from "@tanstack/react-router";
import { toast } from "sonner";
import { login } from "@/api/auth";
import { ApiError } from "@/api/client";
import { Filter } from "lucide-react";

export function LoginPage() {
  const router = useRouter();
  const search = useSearch({ strict: false }) as { next?: string };
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(username, password);
      const next = search.next ?? "/runs";
      router.navigate({ to: next });
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : "Login failed";
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg">
      <form
        onSubmit={onSubmit}
        className="card w-80 p-6 space-y-4 shadow-lg"
      >
        <div className="flex items-center gap-2 font-semibold">
          <Filter className="h-5 w-5 text-accent" />
          <span>Leadsniffer</span>
        </div>
        <p className="text-sm text-muted">Sign in to continue.</p>
        <div>
          <label className="label">Username</label>
          <input
            className="input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
            autoComplete="username"
          />
        </div>
        <div>
          <label className="label">Password</label>
          <input
            type="password"
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>
        <button type="submit" className="btn-primary w-full justify-center" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
